import React, { useMemo } from 'react'
import { Spacer } from '@cleartrip/bento/components/Spacing'
import moment from 'moment'

const InactiveFlow = ({ isInactiveFlow,
  cycleExpirationTime,
  showHiFiveFailurePage }) => {
  const MONTHS_LONG = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nove',
    'Dec'
  ]

  const createdAt = new Date(cycleExpirationTime)

  const a = moment(new Date(cycleExpirationTime))
  const b = moment(new Date())
  const restartDaysCount = a.diff(b, 'days')
  const restartHrsCount = a.diff(b, 'hours')
  const restartMnsCount = a.diff(b, 'minutes')
  const restartSecCount = a.diff(b, 'seconds')

  let duration = restartDaysCount
  if (restartDaysCount > 0) {
    duration = `${restartDaysCount} ${restartDaysCount === 1 ? 'day' : 'days'}`
  } else if (restartDaysCount === 0 &&
    restartHrsCount > 0) {
    duration = `${restartHrsCount} ${restartHrsCount === 1 ? 'hour' : 'hours'}`
  } else if (restartDaysCount === 0 &&
    restartHrsCount === 0 &&
    restartMnsCount > 0) {
    duration = `${restartMnsCount} ${restartMnsCount === 1 ? 'minute' : 'minutes'}`
  } else if (restartDaysCount === 0 &&
    restartHrsCount === 0 &&
    restartMnsCount === 0 &&
    restartSecCount > 0) {
    duration = `${restartSecCount} ${restartSecCount === 1 ? 'second' : 'seconds'}`
  }

  const title = useMemo(() => {
    if (isInactiveFlow) {
      return `${duration} more`
    } if (showHiFiveFailurePage) {
      return 'Time is up!'
    }
  }, [isInactiveFlow, showHiFiveFailurePage, duration])

  const message = useMemo(() => {
    if (isInactiveFlow) {
      return `until you can send Hi-Five requests. You can start again on ${createdAt.getDate()} ${
        MONTHS_LONG[createdAt.getMonth()]
      }.`
    } if (showHiFiveFailurePage) {
      return `No one signed up using your referral link. Try again after ${createdAt.getDate()} ${
        MONTHS_LONG[createdAt.getMonth()]
      }.`
    }
  }, [isInactiveFlow, showHiFiveFailurePage, createdAt, MONTHS_LONG])

  return (
    <div className="w-100p">
      <div className="flex flex-between flex-column pl-9 pr-2 py-9">
        <div className="flex flex-column ">
          <h3 className="c-neutral-900 fs-48 fw-400 ls-normal"> {title}</h3>
          <Spacer className="pb-2" />
          <p className="c-neutral-900 fs-4 ls-normal lh-24 fw-400 ">{message}</p>
        </div>

      </div>
    </div>

  )
}

export default InactiveFlow
